export var Mode;
(function (Mode) {
    Mode["MOBILE"] = "mobile";
    Mode["DESKTOP"] = "desktop";
})(Mode || (Mode = {}));
export var View;
(function (View) {
    View["WEB"] = "web";
    View["MOBILE"] = "mobile";
})(View || (View = {}));
export var MessageType;
(function (MessageType) {
    MessageType["OpenDocumentVersion"] = "onOpenDocumentVersion";
    MessageType["OpenDeepLinkVersion"] = "onOpenDeepLinkVersion";
    MessageType["VersionSelection"] = "onVersionSelection";
    MessageType["RestoreVersion"] = "onRestoreVersion";
    MessageType["Upgrade"] = "onUpgrade";
    MessageType["CreateCopy"] = "onCreateCopy";
    MessageType["Refresh"] = "onRefresh";
    MessageType["ModeChange"] = "onModeChange";
    MessageType["ThemeChange"] = "onThemeChange";
    MessageType["ClosePanel"] = "onClosePanel";
    MessageType["Error"] = "onError";
    MessageType["VersionBookmark"] = "onVersionBookmark";
    MessageType["VersionUnBookmark"] = "onVersionUnBookmark";
    MessageType["VersionBookmarkStart"] = "onVersionBookmarkStart";
    MessageType["VersionUnBookmarkStart"] = "onVersionUnBookmarkStart";
    MessageType["PermanentlyDeleteScreen"] = "onPermanentlyDeleteScreen";
    MessageType["PermanentlyDeleteVersion"] = "onPermanentlyDeleteVersion";
    MessageType["VersioningPanelLoadComplete"] = "onVersioningPanelLoadComplete";
    MessageType["PreviewThumbnailReceived"] = "onPreviewThumbnailReceived";
})(MessageType || (MessageType = {}));
/* eslint-enable @typescript-eslint/no-namespace */
